import { useEffect } from "react";
import "@/App.css";
import { useGameStore, SCREEN } from "@/stores/gameStore";
import { useSettings } from "@/stores/settingsStore";
import { useIntroStore, hasSeenIntro } from "@/stores/introStore";
import { Audio_ } from "@/lib/audio";
import IntroSequence from "@/screens/IntroSequence";
import HomeScreen from "@/screens/HomeScreen";
import PlayMenu from "@/screens/PlayMenu";
import SettingsScreen from "@/screens/SettingsScreen";
import ProfileScreen from "@/screens/ProfileScreen";
import InventoryScreen from "@/screens/InventoryScreen";
import LoadoutScreen from "@/screens/LoadoutScreen";
import StoreScreen from "@/screens/StoreScreen";
import NewsScreen from "@/screens/NewsScreen";
import FriendsScreen from "@/screens/FriendsScreen";
import RecordingsScreen from "@/screens/RecordingsScreen";
import MatchScreen from "@/screens/MatchScreen";
import GenericPanel from "@/screens/GenericPanel";
import { Toaster } from "sonner";

function Router() {
    const screen = useGameStore((s) => s.screen);
    switch (screen) {
        case SCREEN.INTRO: return <IntroSequence />;
        case SCREEN.MENU: return <HomeScreen />;
        case SCREEN.PLAY: return <PlayMenu />;
        case SCREEN.SETTINGS: return <SettingsScreen />;
        case SCREEN.PROFILE: return <ProfileScreen />;
        case SCREEN.INVENTORY: return <InventoryScreen />;
        case SCREEN.LOADOUT: return <LoadoutScreen />;
        case SCREEN.STORE: return <StoreScreen />;
        case SCREEN.NEWS: return <NewsScreen />;
        case SCREEN.FRIENDS: return <FriendsScreen />;
        case SCREEN.RECORDINGS: return <RecordingsScreen />;
        case SCREEN.MATCH: return <MatchScreen />;
        case SCREEN.CAREER:
            return <GenericPanel title="Career" subtitle="Ranked progression" testId="career-screen" empty="Career tracks unlock when Ranked Multiplayer goes live." />;
        case SCREEN.STATISTICS:
            return <GenericPanel title="Statistics" subtitle="Match history & performance" testId="statistics-screen" showStats />;
        default: return <HomeScreen />;
    }
}

function App() {
    const playIntroOnLaunch = useSettings((s) => s.playIntroOnLaunch);
    const goto = useGameStore((s) => s.goto);
    const forceCompleteIntro = useIntroStore((s) => s.forceComplete);

    useEffect(() => {
        Audio_.preload(["hover", "click", "open", "close"]);
        if (!playIntroOnLaunch && hasSeenIntro()) {
            forceCompleteIntro();
            goto(SCREEN.MENU);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className="App">
            <Router />
            <Toaster
                position="top-center"
                theme="dark"
                toastOptions={{
                    style: {
                        background: "rgba(10, 11, 14, 0.9)",
                        border: "1px solid rgba(255, 154, 74, 0.4)",
                        color: "#fff",
                        borderRadius: 0,
                    },
                }}
            />
        </div>
    );
}

export default App;
